import classNames from "classnames";
import "./style.scss";
interface Props {
  className?: string;
  data: string[];
}
export const StackTrace = ({ className, data }: Props) => {
  return (
    <div className={classNames("stacktrace", className)}>
      <div className="stacktrace__main">
        {data.map((line, index) => (
          <div className={classNames("stacktrace__line")} key={`${index}key`}>
            <div
              className="stacktrace__text"
              style={{ marginLeft: `${index}em` }}
            >
              {line}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
